<template>
  <div>
    <search-bar
      @search="searchIQC"
      name=""
      placeholder="输入产品编号、名称、型号、工单号进行查找"
      ref="searchBar"
    />
    <div class="filter-bar">
      <span @click="select">
        年月 {{ period }}
        <i class="caret"></i>
      </span>
      <span>
        {{ querytype }}
        <i class="caret"></i>
      </span>
      <select class="filter-item__select" v-model="querytype" @change="searchIQC">
        <option :value="'按物料'">按物料</option>
        <option :value="'按供应商'">按供应商</option>
      </select>
    </div>
    <div class="weui-cells">
      <router-link
        class="weui-cell weui-cell_access"
        v-for="(item, index) in list"
        :key="index"
        :to="{name: 'OutProductionIQCReportDetail', params: { item, querytype }}"
      >
        <div class="weui-cell__bd">
          <p v-if="querytype == '按物料'">{{item.pr_code}}</p>
          <p v-else>{{item.qc_vendname}}</p>
          <!-- <p class="list-item-muted">{{item.pr_detail}}</p> -->
        </div>
        <div class="weui-cell__ft">
          <p v-if="querytype == '按物料'">{{item.pr_detail}}</p>
          <!-- <p class="list-item-muted">{{item.pr_code}}</p> -->
        </div>
      </router-link>
    </div>
    <div class="list-footer">
      <label class="list-footer__label">合计：{{list.length}}单</label>
    </div>
  </div>
</template>

<script>
import SearchBar from "@/components/SearchBar.vue";

export default {
  components: {
    SearchBar
  },
  data() {
    var year = new Date().getFullYear()
    var month = new Date().getMonth() + 1
    var period
    if(month < 10)period = year + '0' + month
    else period = year + '' + month

    return {
      list: [], // IQC进料明细列表
      querytype: '按物料',
      period
    }
  },
  mounted() {
    this.searchIQC()
  },
  methods: {
    searchIQC() {
      let me = this

      let period = me.period

      let querytype = me.querytype == '按物料' ? 'prod' : 'vendor'

      let searchBar = me.$refs.searchBar
      let keyword = searchBar.keyword

      let params = {
        yearmonth: period,
        querytype
      }
      if(keyword) {
        params.con = me.querytype == '按物料' ?
          "(pr_code like '%" + keyword + "%' or pr_detail like '%" + keyword + "%' or pr_orispeccode like '%" + keyword + "%' or pr_brand like '%" + keyword + "%')" :
          "(qc_vendname like '%" + keyword + "%')"
      }

      me.$ajax({
        url: "/api/qc/report/iqc",
        params,
      }).then(function (res) {
        if (res.success) {
          me.list = res.data
        }
      });
    },
    select() {
      var me = this,
        year = new Date().getFullYear(),
        month = new Date().getMonth() + 1,
        years = [],
        months = [
          {value: '01', label: '1月'}, 
          {value: '02', label: '2月'},
          {value: '03', label: '3月'},
          {value: '04', label: '4月'},
          {value: '05', label: '5月'},
          {value: '06', label: '6月'},
          {value: '07', label: '7月'},
          {value: '08', label: '8月'},
          {value: '09', label: '9月'},
          {value: '10', label: '10月'},
          {value: '11', label: '11月'},
          {value: '12', label: '12月'},
        ]
      for (let i = year - 20, len = year; i <= len; i++) {
        years.push({
          value: i,
          label: i + "年"
        });
      }
      me.$weui.picker(
        years,
        months,
        {
          title: "选择年月",
          defaultValue: [year, month],
          onConfirm: function (r) {
            me.period = r[0].value + r[1].value
            me.searchIQC()
          },
        }
      );
    }
  }
}
</script>

<style scoped>
.filter-bar {
  width: 100%;
  background: var(--weui-BG-2);
  box-sizing: border-box;
  text-align: center;
  font-size: 13px;
  padding: 11px 0 9px 0;
  color: #9b9b9b;
  margin-bottom: 1px;
  display: flex;
  position: relative;
}
.filter-bar span {
  margin: 0 auto;
  flex: 1;
}
.filter-item__select {
  position: absolute;
  margin: 0;
  padding: 0;
  border: 0;
  top: 0;
  right: 0;
  width: 50%;
  height: 100%;
  opacity: 0;
}
.filter-item__select option{
  color: var(--weui-FG-0);
  background: var(--weui-BG-2);
}
</style>